const ru = {
  AuthTitle: {
    Greetings: "Добро пожаловать в",
  },
  Auth: {
    EnterEmail: "Введите email",
    EnterPassword: "Введите пароль",
    AgreeWith: "Я согласен с",
    ProcessingPersonalData: "обработкой персональных данных",
    UserAgreement: "пользовательским соглашением",
    EmailRequiredError: "Email обязателен",
    EmailWrongFormatError: "Неправильный формат email!",
    PasswordRequiredError: "Пароль обязателен",
    ForgotPassword: "Не помню пароль",
  },
  Login: {
    Title: "Авторизация",
    Subtitle: "Заполните поля ниже, чтобы войти в свою учетную запись.",
    Login: "Войти",
    Register: "Регистрация",
    LoginError: "Введен неправильный логин или пароль",
    BuyTeacherLessons: "Купить уроки с учителем",
  },
  Register: {
    Title: "Регистрация",
    Subtitle:
      "Заполните поля ниже, чтобы зарегистрировать свою учетную запись.",
    Register: "Регистрация",
    Login: "Вход",
    EnterLastName: "Введите фамилию",
    EnterFirstName: "Введите имя",
    EnterEmail: "Введите email",
    EnterGender: "Пол",
    EnterBirthday: "Дата рождения",
    EnterProfileCountryId: "Гражданство",
    EnterProfileCityId: "Город пребывания",
    EnterProfileDegreeId: "Образование",
    EnterPassword: "Введите пароль",
    RepeatPassword: "Повторите пароль",
    LastNameRequiredError: "Фамилия обязательна",
    LastNameMinLengthError: "Минимум 2 символа",
    FirstNameRequiredError: "Имя обязательно",
    FirstNameMinLengthError: "Минимум 2 символа",
    PhoneRequiredError: "Телефон обязательный",
    PhoneInvalidError: "Неправильный формат телефона",
    GenderRequiredError: "Пол обязательный",
    BirthdayRequiredError: "Дата рождения обязательна",
    ProfileCountryIdRequiredError: "Гражданство обязательно",
    ProfileCityIdRequiredError: "Город пребывания обязателен",
    ProfileDegreeIdRequiredError: "Образование обязательно",
    PasswordMismatchError: "Пароли не совпадают",
    PasswordMinLengthError: "Минимум 6 символов",
  },
  Reset: {
    Title: "Cброс пароля",
    Subtitle:
      "Введите email указанный Вами при регистрации и нажмите кнопку «Восстановить»",
    Reset: "Восстановить",
    Login: "Вход",
    Success:
      "В течение нескольких минут вы получите письмо на почту <0>{{email}}</0> с инструкциями по восстановлению пароля.",
  },
  CookieNotice: {
    Message:
      "Для улучшения работы сайта и его взаимодействия с пользователями мы используем файлы cookie. Продолжая работу с сайтом, Вы разрешаете использование cookie-файлов.  Вы всегда можете отключить файлы cookie в настройках Вашего браузера.",
    Agree: "Принять, не показывать больше",
  },
  MainPage: {
    Title: "Главная",
    TitleGreetings: "Добро пожаловать в",
    TitleGreetingsMiddle: "ГОВОРИ",
    TitleGreetingsEnd: "РУ!",
    MyCourses: "Мои курсы",
    CourseContinue: "ПРОДОЛЖИТЬ",
    CourseCountStart: "Вам доступно",
    CourseCount_zero: "{{count}} курсов",
    CourseCount_one: "{{count}} курс",
    CourseCount_few: "{{count}} курса",
    CourseCount_many: "{{count}} курсов",
    AllCourses: "Все курсы",
    MyLessons: "Мои уроки",
    AllLessons: "все уроки",
    EmptyCourses: "Нет курсов",
    EmptyLessons: "Нет уроков",
    BuyTeacherLessons: "Купить уроки с учителем",
    BuyTeacherLessonsLink: "здесь",
    ForeignCardTooltip: "Для карт не из Российской Федерации",
    NoActiveLicense: "У вас нет активной лицензии.",
    GoIntoLesson: "На урок",
    FinishedLessons: "Проведено",
    CanceledLessons: "ОТМЕНЕНО",
  },
  CoursesPage: {
    Title: "Курсы",
    TitleGreetings: "Добро пожаловать в",
    MyCourses: "Мои курсы",
    CourseContinue: "ПРОДОЛЖИТЬ",
    EmptyCourses: "Нет курсов",
    SearchPlaceholder: "Поиск по названию",
    LevelPlaceholder: "Уровень",
    AllLevels: "Все уровни",
  },
  Menu: {
    Main: "Главная страница",
    Words: "Слова",
    Courses: "Мои курсы",
    Lessons: "Уроки с учителем",
    TeacherCorner: "Творческие задания",
    AdditionalCourses: "Доп. курсы",
    UsefulLinks: "Полезные ссылки",
    Notifications: "Уведомления",
    Video: "Видео",
    TeacherGroups: "Группы",
    TeacherAttendance: "Посещаемость",
    TeacherClasses: "Занятия",
    TeacherReports: "Отчеты",
    CreativeTasks: "Творческие задания",
    Attendance: "Посещаемость",
  },
  Footer: {
    Copyright: "Все права защищены",
    About: "О компании",
    PrivacyPolicy: "Политика использования данных",
    PrivacyProtect: "Положение об обработке и защите персональных данных",
  },
  Module: {
    exercise_one: "упражнение",
    exercise_two: "упражнения",
    exercise_few: "упражнений",
    Completed: "Сделано",
    Result: "Результат",
    InWork: "В работе",
    Done: "Завершен",
  },
  SteppedProgress: {
    Completed: "Завершено",
  },
  CourseDetails: {
    Title: "Информация о курсе",
    Progress: "Прогресс",
    Completed: "СДЕЛАНО",
    Result: "РЕЗУЛЬТАТ",
    Hours: "Часы",
    Lessons: "Уроки",
    Units: "Разделы",
    Unit: "Раздел",
    Exercises_zero: "{{count}} упражнений",
    Exercises_one: "{{count}} упражнение",
    Exercises_few: "{{count}} упражнения",
    Exercises_many: "{{count}} упражнений",
  },
  CourseUnitDetails: {
    Vocabulary: "Слова",
    Video: "Видео",
    Grammar: "Грамматика",
    Reading: "Чтение",
    Writting: "Письмо",
    Speaking: "Говорение",
    Test: "Тест",
    Unknown: "Неизвестный",
    EmptyExercises: "Нет упражнений",
  },
  EntranceTest: {
    ModalTitle: "Определите уровень знаний",
    ModalBody:
      "Пройдите тест, чтобы определить ваш уровень владения Русским языком. Прохождение тестирования занимает в среднем 40 минут.",
    Cancel: "Отмена",
    Take: "Перейти к заданию",
  },
  TeacherPage: {
    Title: "Главная учителя",
    MyLessons: "Мои занятия",
    MyModules: "Мои модули",
  },
  DistributorPage: {
    Title: "Главная дистрибьютора",
  },
  CoordinatorPage: {
    Title: "Главная координатора",
  },
  Distributor: {
    Report: "Отчеты",
    DateFrom: "С даты",
    DateTo: "По дату",
    Status: "Статус",
    StatusReady: "Готов",
    StatusPlanned: "Обрабатывается",
    Actions: "Действия",
    FromRequiredError: "Укажите дату начала",
    ToRequiredError: "Укажите дату окончания",
  },
  Button: { Send: "Отправить", Download: "Скачать" },
  LessonsTable: {
    GroupName: "Группы",
    Status: "Статус",
    StartDateTime: "Дата и время",
    Duration: "Ак. ч",
    Credentials: "Вебинар: Логин/Пароль",
    CredentialsCopied: "Скопированно!",
    SortAlpabetically: "По алфавиту А-Я",
  },
  LessonStatuses: {
    completed: "Проведено",
    planned: "Запланировано",
    earlyCanceledByCustomer: "Заблаговременная отмена слушателями",
    earlyCanceledBySchool: "ДС Заблаговременная отмена",
    lateCanceledByCustomer: "Поздняя отмена слушателями",
    lateCanceledBySchool: "ДС Поздняя отмена",
    notPerformedToPay: "К оплате",
  },
  LessonAttendance: {
    Status: "Выберите статус",
    Date: "Выбрать дату",
    Time: "Выбрать время",
    Duration: "Продолжительность",
    AH: "ак.ч",
    Students: "Студенты",
    CheckAll: "Отметить всех",
    Comment: "Комментарий",
    Submit: "Готово",

    restrictiveBackDateError: "Дата не может быть меньше разрешенной",
    restrictiveForwardDateError: "Дата не может быть больше разрешенной",
    commentSizeError: "Комментарий должен быть меньше {{count}} слов",
    requiredFieldError: "Это поле обязательно к заполнению",
    requiredDateError: "Заполните дату и время",
    ExcessHoursWarning: "Количество часов превышено",
    MarkStudents:
      "Отметьте учащихся, которые посетили занятие, и сохраните изменения.",

    apiError:
      "Ваши изменения не сохранены. Пожалуйста напишите на online@dschool.ru",
    early_cancel_by_customer_not_acceptable:
      "Ранняя отмена пользователем недоступна, уже отменены 2 занятия, обратитесь к координатору",
    early_cancel_by_school_not_acceptable:
      "Ранняя отмена школой недоступна, уже отменены 2 занятия, обратитесь к координатору",
  },
  TeacherReportsPage: {
    Title: "Отчёты",
    HeaderTitle: "Отчёты",
    CreateReport: "создать отчет",
  },
  TeacherReportTable: {
    Title: "Название отчета",
    CreationDate: "Дата создания",
    Period: "Период",
    Status: "Статус",
    StatusDone: "готово",
    StatusPending: "построение",
    Actions: "Действия",
    Statistics: "Статистика по платформе",
    CourseProgress: "Прогресс по курсу",
    ActiveTime: "Отчет по времени на платформе",
    EntranceTest: "Входное тестирование",
    LecenseReport: "Отчет по использованным лицензиям",
    HeaderTitle: "Отчеты",
    CreateReport: "Создать отчет",
    DeleteReport: "Вы уверены?",
    DeleteTooltip: "Удалить",
    MailTooltip: "Отправить на email",
    DownloadTooltip: "Скачать",
    DeleteGroupTooltip: "Удалить выбранные",
    MailGroupTooltip: "Отправить выбранные на email",
    DownloadGroupTooltip: "Скачать выбранные",
  },
  CreateReportForm: {
    Statistics: "Статистика по платформе",
    CourseProgress: "Прогресс по курсу",
    ActiveTime: "Отчет по времени на платформе",
    Report: "Мой отчет",
    Title: "Создание отчёта",
    Type: "Вид отчета",
    TypeLabel: "Тип",
    NameLabel: "Название",
    DateLabel: "Дата",
    DateFromLabel: "От",
    DateToLabel: "По",
    Name: "Название отчета",
    Period: "Период",
    PeriodFrom: "От",
    PeriodTo: "По",
    Date: "Дата",
    FilterListGroup: "Группа",
    FilterListStudent: "Студент",
    FilterListCompany: "Компания заказчик",
    FilterListTest: "Название входного отчета",
    FilterListSelectedStudents: "Фильтр групп, выбрано {{count}} студентов",
    FilterListSelectedGroups: "Фильтр групп, выбрано {{count}} групп",
    FilterListSelectedCompanies: "Фильтр групп, выбрано {{count}} компаний",
    FilterListSelectedTests: "Фильтр групп, выбрано {{count}} входных тестов",
    FilterListSelectedPlaceholderStudents: "Выбрать студентов",
    FilterListSelectedPlaceholderGroups: "Выбрать группы",
    FilterListSelectedPlaceholderCompanies: "Выбрать компании-клиенты",
    FilterListSelectedPlaceholderTests: "Выбрать вступительные тесты",
    GroupsChosen: "Выбранные группы",
    ChooseAll: "Выбрать все",
    RemoveAll: "Удалить все",
    GroupName: "Группа",
    GroupDefault: "Группировать по умолчанию",
    Cancel: "Отмена",
    Create: "Создать",
    TitleRequiredError: "Необходим заголовок",
    FromRequiredError: "Укажите дату начала периода",
    ToRequiredError: "Укажите дату окончания периода",
    GroupsRequiredError: "Выберите одну или несколько групп!",
    OrderCreateError: "Не удалось создать новый отчет",
    FieldRequiredError: "Поле обязательно",
    NoItems: "Групп нет",
  },
  Gender: {
    Male: "Мужской",
    Female: "Женский",
  },
  Role: {
    student: "Студент",
    teacher: "Учитель",
    distributor: "Дистрибьютор",
    coordinator: "Координатор",
  },
  EmailNotConfirmed: {
    Title:
      "Для входа на платформу на ваш электронный адрес, {{email}}, отправлено письмо. Просим подтвердить ваш адрес. В случае возникновения вопросов пишите online@dschool.ru",
    Back: "<< Вернуться",
  },
  MyWordsPage: {
    Title: "Мои слова",
    EmptyWordList: "Нет слов для изучения. Выберите другой раздел в фильтрах",
  },
  WordsFilter: {
    Title: "Фильтры",
    Clear: "Очистить",
    EmptyCourses: "Список курсов пуст",
    ChooseCourse: "Выберите курс",
    ChooseUnit: "Выберите раздел",
    EmptyUnits: "Список разделов пуст",
  },
  SetupPassword: {
    Title: "Установка пароля",
    Subtitle:
      "Вам необходимо установить новый пароль, введите новый пароль и подтверждение в поля ниже",
  },
  SetupPasswordRedirect: {
    Title: "Требуется действие",
    Description:
      "Вы должны установить пароль, чтобы продолжить пользоваться данным сервисом",
    Redirect: "Установить пароль",
  },
  ChangePassword: {
    Password: "Пароль",
    PasswordRepeat: "Подтверждение пароля",
    Confirm: "Подтвердить",
    PasswordShortError: "Длина пароля должна быть больше 6 символов",
    PasswordMismatch: "Пароли должны совпадать",
    Success: "Пароль успешно изменен",
    Login: "На страницу авторизации",
  },
  ProfilePage: {
    Title: "Мой профиль",
  },
  Profile: {
    PersonalData: "Личная информация",
    FirstName: "Имя",
    LastName: "Фамилия",
    BirthDate: "Дата рождения",
    Citizenship: "Гражданство",
    Degree: "Образование",
    City: "Город прибывания",
    NewPassword: "Новый пароль",
    ConfirmNewPassword: "Подтвердить новый пароль",
    Password: "Пароль",
    Save: "Сохранить",
    DataUpdateSuccess: "Данные успешно обновлены",
    Settings: "Настройки",
    ShowPassingResults: "Отображать результат прохождения",
  },
  UsefulLinks: {
    Title: "Полезные ссылки",
    GroupName: "Учебная группа:",
    Added: "Добавлена",
    NoLinks: "Ссылок нет",
  },
  DatePicker: {
    Today: "Сегодня",
    Clear: "Очистить",
  },
  Promocode: {
    Expired: "Зачисление в группу прекращено. Обратитесь к  вашему менеджеру",
  },
  TeachersAutocompleteFilter: {
    EnterTeacherName: "Учителя не найдены",
    SelectTeacher: "Выбор учителя",
  },
  Loading: {
    Error: "Ошибка загрузки, попробуйте обновить страницу",
  },
  MultipleSelect: {
    SelectAll: "Выбрать все",
  },
  Attendance: {
    Title: "Посещаемость",
  },
  CreativeTasks: {
    Title: "Творческие задания",
  },
};

export default ru;
